<template>
  <div id="basic">
    <div class="topBan">
      创建公司
    </div>
    <div class="top_div_update">
      <div class="top_div_updates">
        <el-form
          label-position="right"
          label-width="120px"
          :model="datalist"
          ref="datalist"
          :rules="rules"
        >
          <el-form-item label="公司名称" prop="company_name">
            <el-input class="inpit_update" v-model="datalist.company_name"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="user_name">
            <el-input class="inpit_update" v-model="datalist.user_name"></el-input>
          </el-form-item>
          <el-form-item label="邀请码" prop="invite_code">
            <!-- <a
              v-if="!datalist.invite_code"
              style="cursor: pointer;color:rgb(38, 28, 175);text-align:left"
              @click="getCode"
            >获取邀请码</a> -->
            <el-input class="inpit_update" v-model="datalist.invite_code" ></el-input>
          </el-form-item>
          <el-form-item label="省份" prop="province">
            <el-input class="inpit_update" v-model="datalist.province"></el-input>
          </el-form-item>
          <el-form-item label="城市" prop="city">
            <el-input class="inpit_update" v-model="datalist.city"></el-input>
          </el-form-item>
          <el-form-item label="地区" prop="district">
            <el-input class="inpit_update" v-model="datalist.district"></el-input>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input class="inpit_update" v-model="datalist.address"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contact_person">
            <el-input class="inpit_update" v-model="datalist.contact_person"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact_mobile">
            <el-input class="inpit_update" v-model="datalist.contact_mobile"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="passwd">
            <el-input class="inpit_update" v-model="datalist.passwd" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <div style="width:100%;display:flex;">
              <el-button class style="flex:1;" type="primary" @click="submitForm('datalist')">提交</el-button>
              <el-button style="flex:1" @click="goToLogin">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datalist: {
        invite_code: '',
      },
      rules: {
        company_name: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        user_name: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        passwd: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        invite_code: [
          { required: true, message: '邀请码不能为空', trigger: 'change' },
        ],

        province: [
          { required: true, message: '省份不能为空', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' },
        ],
        contact_person: [
          { required: true, message: '联系人不能为空', trigger: 'blur' },
        ],
        contact_mobile: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' },
        ],
        city: [
          {
            required: true,
            message: '城市不能为空',
            trigger: 'blur',
          },
        ],
        district: [
          {
            required: true,
            message: '地区不能为空',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    onSubmit() {
      this.setubmit();
    },
    setubmit() {
      const url = this.$userList.user_company;
      const list = {...this.datalist}
      list.passwd = this.$sha256(list.passwd);
      this.$http.post(url, list).then(res => {
        if (res.code === 200) {
          if (res.data.exist_company_or_user_name_or_mobile) {
            this.$alert('存在公司或用户名或移动电话');
            return;
          }
          if (res.data.exist_invite_code) {
            this.$alert('邀请码已存在');
            return;
          }
          if (res.data.token) {
            this.$message({
              type: 'success',
              message: '新增成功!',
            });
            this.$router.push({path:'/login'});
            return;
          }
        } else {
          //res.message && this.$alert(res.message);
        }
      });
    },
    // getCode() {
    //   const url = this.$userList.user_invite_code;
    //   this.$http.get(url).then(res => {
    //     if (res.code === 200) {
    //       this.datalist.invite_code = res.data.code;
    //       console.log(this.datalist, res.data);
    //     } else {
    //       //res.message && this.$alert(res.message);
    //     }
    //   });
    // },
    goToLogin() {
      this.$router.go(-1);
    },
  },
  created() {
    // this.getubmit()

    this.$root.setheadName();
  },
};
</script>

<style scoped>
#basic {
  color: #2c3e50;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /* https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg */
  background: url('https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg')
    no-repeat;
}
.top_div_updates {
  width: auto;
}
.top_div_update {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  min-height: 200px;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.inpit_update {
  width: 500px;
  overflow: hidden;
  display: flex;
}
.img_class_up {
  width: 500px;
}
.update_s {
  margin-right: 20px;
  overflow: hidden;
  display: flex;
}
.topBan{
  width: 100%;
  height: 50px;
  background: #fff;
  border-bottom: solid 1px #000;
  line-height: 50px;
  font-weight: 900;
  text-align: center;
}
</style>
